/*
 * @Author: chenxing
 * @Date: 2021-03-04 17:11:04
 * @LastEditors: Yran
 * @LastEditTime: 2022-01-26 11:06:33
 */
import axios from '@/utils/axios';

const apiUrl = {
  // finance: 'https://47.111.242.209:8070/login',
  finance: 'https://115.190.242.236:8070/login',
  // finance: 'http://10.0.0.117:8070/login',
};


export function addfinance(params) {
  //保存二级代理商基础信息信息
  //  return axios.get(apiUrl.finance+'?start_date='+params.start_date+'&end_date='+params.end_date+'&usename='+params.usename);
  window.open(apiUrl.finance+'?start_date='+params.start_date+'&end_date='+params.end_date+'&report_type='+params.report_type);
}